import { CommonModule, NgIf } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DialogConfirmDeleteComponent } from 'src/app/core/dialog/dialog-confirm-parker-delete/dialog-confirm-delete.component';
import { DataService } from 'src/app/core/services/data/data.service';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import {
  IAdditionalCredentialNewRequest,
  IAddtitionalCredentialRespone,
  IParkerProfileDetail,
} from 'src/app/shared/interfaces';

@Component({
  selector: 'app-parkers-v2-additional-credentials',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    MatCardModule,
    NgIf,
    CommonModule,
    MatButtonModule,
    IgxGridModule,
  ],
  templateUrl: './parkers-v2-additional-credentials.component.html',
  styleUrl: './parkers-v2-additional-credentials.component.scss',
})
export class ParkersV2AdditionalCredentialsComponent implements OnInit {
  _parkerDetail: IParkerProfileDetail;
  doNotDisplay: boolean = false;

  @Input() set parkerDetail(value: IParkerProfileDetail) {
    this._parkerDetail = value;
  }

  additionalCredentials: IAddtitionalCredentialRespone[] = [];
  credentialForm: FormGroup;
  isProcessing: boolean = false;

  gridFontSize: number = 12;
  currentlyActiveRow: number = -1;

  _messageService = inject(MessageDialogService);
  _appGeneralState = inject(AppGeneralStateService);

  constructor(
    private dataService: DataService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.initCredentialForm();

    this.getAllAdditionalCredentialsForParker(this._parkerDetail.parkerId);
  }

  initCredentialDisplayType(): void {
    this.doNotDisplay = this._appGeneralState.credentialTypeListForCurrentLotNumber.some((credential) => credential.doNotDisplay === true);
    console.log('additionalCredentials:', this.additionalCredentials);
    console.log('doNotDisplay:', this.doNotDisplay);  
  }

  initCredentialForm(): void {
    try {
      this.credentialForm = new FormGroup({
        credentialTypeId: new FormControl('', [Validators.required]),
        credentialValue: new FormControl('', [Validators.required]),
      });
    } catch (err) {
      console.error('Error on init credential form ' + JSON.stringify(err));
    }
  }

  onResetAdditionalCredentialData(): void {
    this.credentialForm.patchValue({
      credentialTypeId: '',
      credentialValue: '',
    });
  }

  onSubmitAddNewCredential(): void {
    let newCredential: IAdditionalCredentialNewRequest = {} as IAdditionalCredentialNewRequest;

    newCredential.parkerId = this._parkerDetail.parkerId;
    newCredential.credentialTypeId = this.credentialForm.get('credentialTypeId')!.value;
    newCredential.credentialValue = this.credentialForm.get('credentialValue')!.value;

    this.postAdditionalCredential(newCredential);
  }

  postAdditionalCredential(credentialData: IAdditionalCredentialNewRequest): void {
    this.isProcessing = true;

    this.dataService.additionalCredentialAddNewCredential(credentialData).subscribe(
      (res) => {},
      (err: any) => {
        this.isProcessing = false;
        this._messageService.snackBarTopCenterTimed(
          'Error occurred while adding the credential. Please try again.',
          5000,
        );
      },
      () => {
        this.isProcessing = false;

        this.getAllAdditionalCredentialsForParker(this._parkerDetail.parkerId);

        this.initCredentialForm();
        this._messageService.snackBarTopCenterTimed('This Credential has been successfully saved.', 5000);
      },
    );
  }

  onDeleteCredential(additionalCredentialId: number): void {
    const dialogRef = this.dialog.open(DialogConfirmDeleteComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.deleteAdditionalCredential(additionalCredentialId);
    });
  }

  deleteAdditionalCredential(additionalCredentialId: number): void {
    this.isProcessing = true;

    this.dataService.additionalCredentialDeleteExistingCredential(additionalCredentialId).subscribe(
      (res) => {},
      (err: any) => {
        this.isProcessing = false;
      },
      () => {
        this.isProcessing = false;

        let action: any;
        this.snackBar.open('This credential has been successfully deleted.', action, {
          duration: 3000,
        });

        this.getAllAdditionalCredentialsForParker(this._parkerDetail.parkerId);
      },
    );
  }

  getAllAdditionalCredentialsForParker(parkerId: string): void {
    this.dataService.getAdditionalCredentialListForAParkerId(parkerId).subscribe(
      (res) => {
        this.additionalCredentials = res;
      },
      (err: any) => {},
      () => {
        this.initCredentialDisplayType();
      },
    );
  }

  keyPressCardNumber(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9\-\._:]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  public onKeyDown(keyDown: KeyboardEvent): void {
    if (keyDown.code == 'Space') keyDown.stopPropagation();
  }

  getQSRRowBackgroundColor(rowNumber: number): string {
    if (this.currentlyActiveRow === rowNumber) {
      return 'yellow';
    } else {
      if (rowNumber % 2 === 1) return '#e1e1e4';
      else return '#fff';
    }
  }
}
